import React from "react";
import { Box } from "@mui/material";

// Naye page components ko import karein
import Analytics from "../Pages/Analytics/Analytics";
import ProfilePage from "../Pages/Profile/ProfilePage";
import AddLink from "../Pages/Youtubes/AddLink";
import UpdateLink from "../Pages/Youtubes/UpdateLink";
import Youtube from "../Pages/Youtubes/Youtube";
import BlogEditor from "../Pages/Blogs/BlogEditor";

const DashboardContent = ({ activePage, user }) => {
  // Page render karne ke liye switch statement ka istemal karein
  const renderContent = () => {
    switch (activePage) {
      case "analytics":
        return <Analytics user={user} />;

      case "youtube":
        return <Youtube />;

      case "addLink":
        return <AddLink />;

      case "updateLink":
        return <UpdateLink />;
      case "blogEditor":
        return <BlogEditor />;

      case "profile":
        return <ProfilePage user={user} />;

      default:
        return <Analytics user={user} />;
    }
  };

  return (
    <Box
      sx={{
        minHeight: "calc(100vh - 120px)", // Toolbar aur padding ko consider kare
        display: "flex",
        flexDirection: "column",
        width: "100%",
        // Overflow control
        overflow: "hidden",
      }}
    >
      {renderContent()}
    </Box>
  );
};

export default DashboardContent;
